define('responsive-gameday/views/Monitor/ViewModels/distributors/VideoAdvertisingDistributor',['require','exports','module','../../Events/ViewModelUpdateEvents','../../Events/SceneStateEvents','message-service/message-service','GameDayCore/GDModel/enums/datasources/Datasources'],function(require, exports, module) {
	var UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
		SceneStates = require("../../Events/SceneStateEvents"),
		MessageService = require("message-service/message-service"),
		Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources");
	var gameData,
		sceneData;


	exports.setGameData = function(game, scenes) {
		gameData = game || gameData;
		sceneData = scenes || sceneData;
		this.prepareForDispatch();

		MessageService.off(UpdateEvents.REQUEST_VIDEO_AD_STATUS, exports.handleUpdateRequest);
		MessageService.on.call(this, UpdateEvents.REQUEST_VIDEO_AD_STATUS, exports.handleUpdateRequest);
	};


	exports.prepareForDispatch = function() {
		var evt = null;

		if (sceneData[SceneStates.MID_INNING]) {
			evt = SceneStates.MID_INNING;
		} else if (sceneData[SceneStates.NEW_HALF_INNING]) {
			evt = SceneStates.NEW_HALF_INNING;
		}

		if (evt !== null) {
			MessageService.publish(evt);
		}
	};


	exports.handleUpdateRequest = function() {
		this.prepareForDispatch();
	};
});
